import Vue from 'vue'
import Vuex from 'vuex'

// import example from './module-example'
import auth from './auth'
import admin from './admin'
import adminSearch from './admin/search'
import adminSunatTicket from './admin/sunat/ticket'
import adminSunatDocument from './admin/sunat/document'
import adminSunatNotDomiciled from './admin/sunat/not-domiciled'
import lottery from './admin/lottery'
import adminTrivias from './admin/trivias'

Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default function (/* { ssrContext } */) {
  const Store = new Vuex.Store({
    modules: {
      auth,
      admin,
      adminSunatTicket,
      adminSunatDocument,
      adminSunatNotDomiciled,
      adminSearch,
      lottery,
      adminTrivias
    },

    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEBUGGING
  })

  return Store
}
